import {api} from '../_services'

const state = {
    hashtagSets: [],
    setToBeEdited: [],
    loaded : false
}

const getters = {
    getHashtagSets: state => {
        return state.hashtagSets
    },
    getSetToBeEdited: state => {
        return state.setToBeEdited
    },
    getLoaded: state =>{
        return state.loaded
    }
}

const mutations = {
    fetchHashtagSets: state => {
        api.tagsetRead()
            .then(response => {
                //get the tagsets
                let sets = response.data.tagsets
                let enhancedSets = []
                //loop through each set
                sets.forEach(function(element) {
                    let newSet = {}
                    let x = []
                    let tags = element.stats
                    //loop through hashtags of each set
                    tags.forEach(function(element){
                        let colorCode = element.color
                        switch (colorCode) {
                            case 0:
                                colorCode = 'unused'
                                break
                            case 1:
                                colorCode = 'overused'
                                break
                            case 2:
                                colorCode = 'poor'
                                break
                            case 3:
                                colorCode = 'good'
                                break
                            case 4:
                                colorCode = 'instagram'
                                break
                        }
                        let isSelected = colorCode+'Selected'
                        x.push({
                            name: '#'+element.tag,
                            classObject: {
                                'tagstyleBig': true,
                                [colorCode]: true,
                                [isSelected]: false
                            },
                            colorCode: element.color,
                            tweets: element.tweets,
                            retweets: element.retweets,
                            exposure: element.exposure,
                            selected: false
                        })
                    })
                    // set elements of new set and push to enhanced sets array
                    newSet.name = element.name
                    newSet.tags = x
                    newSet.id = element.id
                    enhancedSets.push(newSet)
                })
                state.hashtagSets = enhancedSets
                state.loaded = true
            })
            .catch(err => {
                // todo
                this.$notify({type: 'error', text: 'Oops! There was an error. Check your internet connection and refresh the page'})
            })
    },
    changeEdited: (state, editedSet) => {
        state.setToBeEdited = editedSet
    },
    deleteSet: async (state, id) => {
        await api.tagsetRemove(id)
        // todo
        const index = state.hashtagSets.map(x => x.id).indexOf(id)
        if (index > -1) {
            state.hashtagSets.splice(index, 1)
        }
    }
}

const actions = {
    setHashtagSets: (context) => {
        context.commit('fetchHashtagSets')
    },
    changeSetToBeEdited: (context, payload) => {
        context.commit('changeEdited', payload)
    },
    setDeleteSet: async (context, payload) => {
        await context.commit('deleteSet', payload)
        // context.commit('fetchHashtagSets')
    }
}

export const hashtagSets = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
